export const templateSpec = {
  inline: true,
  attrs: {
    attributePath: {
      default: ''
    },
    fallback: {
      default: ''
    }
  },
  group: 'inline',
  selectable: true,
  parseDOM: [{
    tag: 'span.embercom-prosemirror-composer-template',
    getAttrs(dom) {
      return {
        attributePath: dom.getAttribute('data-template-identifier'),
        fallback: dom.getAttribute('data-template-fallback')
      };
    }
  }],
  toDOM(node) {
    let value = node.attrs.attributePath;
    let fallback = node.attrs.fallback;
    let resolver = node.type.spec.infoResolver;
    let humanReadableValue = resolver?.humanReadable(value);
    let classes = ['embercom-prosemirror-composer-template', 'intercom-interblocks-template'];
    if (resolver && !resolver.isValid(value)) {
      classes.push('invalid');
    }
    if (resolver && resolver.requiresFallback(value, fallback)) {
      classes.push('requires-fallback');
    }
    return ['span', {
      class: classes.join(' '),
      'data-template-identifier': value,
      'data-template-fallback': fallback
    }, humanReadableValue];
  }
};